const RequestType = {
    GET_USER: 'GetUser',

    DELETE_USER: 'DeleteUser',

    GET_FRIENDS: 'GetFriends',

    SET_FRIEND_DELETED_BY_USER: 'SetFriendDeletedByUser',

    FORGET_FRIEND: 'ForgetFriend',

    SET_FRIENDS_SEEN: 'SetFriendsSeen',
};

module.exports = RequestType;
